import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home/home.vue'

import message from '@/pages/message/message.vue'
import systemMessage from '@/pages/message/systemMessage.vue'
import messageDetails from '@/pages/message/messageDetails.vue'
import payMessage from '@/pages/message/payMessage.vue'



import wallet from '@/pages/wallet/wallet.vue'
import withdrawal from '@/pages/wallet/withdrawal.vue'
import orderList from '@/pages/orderList/orderList.vue'
import orderDetails from '@/pages/orderDetails/orderDetails'//订单详情
import address from '@/pages/address/address.vue'
import addAddress from '@/pages/address/addAddress.vue'
import coupon from '@/pages/coupon/coupon.vue'
import invitation from '@/pages/invitation/invitation.vue'
import authentication from '@/pages/authentication/authentication.vue'
// 下单

import pieceOrder from '@/pages/order/pieceOrder' //拼单
import placeOrder from '@/pages/order/placeOrder' //直接下单


import edit_user from '@/pages/editUser/editUser' //直接下单


import navMenu from '@/components/navMenu'
import menu from '@/components/menu'

import test from '@/pages/test'

Vue.use(Router)

let router =  new Router({
  routes: [
    
    {
      path: '/',
      redirect:'/home'
    },{
      name:'test',
      path:'/test',
      component:test
    },{
      path: '/navMenu',
      component:navMenu,
      children:[
        {
          name:'home',
          path:'/home',
          component:home
        },
        {
          name:'place_order',
          path:'/place_order',
          component:placeOrder
        },
        {
          name:'piece_order',
          path:'/piece_order',
          component:pieceOrder
        },
        {
          name:'menu',
          path:'/menu',
          component:menu,
          children:[
            
            {
              name:'edit_user',
              path:'/edit_user',
              component:edit_user
            },{
              name:'message',
              path:'/message',
              component:message
            },{
              name:'systemMessage',
              path:'/systemMessage',
              component:systemMessage
            },{
              name:'payMessage',
              path:'/payMessage',
              component:payMessage
            },{
              name:'messageDetails',
              path:'/messageDetails',
              component:messageDetails
            },
            {
              name:'wallet',
              path:'/wallet',
              component:wallet
            },{
              name:'withdrawal',
              path:'/withdrawal',
              component:withdrawal
            },
            {
              name:'orderList',
              path:'/orderList',
              component:orderList
            },{
              name:'orderDetails',
              path:'/orderDetails',
              component:orderDetails
            },
            {
              name:'address',
              path:'/address',
              component:address
            },{
              name:'add_address',
              path:'/add_address',
              component:addAddress
            },
            {
              name:'coupon',
              path:'/coupon',
              component:coupon
            },{
              name:'invitation',
              path:'/invitation',
              component:invitation
            },{
              name:'authentication',
              path:'/authentication',
              component:authentication
            }
          ]
          
        }
      ]
    }
  ]
})
router.beforeEach((to, from, next) => {
  let user = JSON.parse(localStorage.getItem('userMessage') || '{}');
  if (user && user.token) {
    next()
  }else {
    localStorage.removeItem('userMessage');
    if(to.path === '/home'){
      next();
    }else{
      next({path:'/home'})
    }
      
  }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js